import React, { useState } from 'react';
import { Link, Navigate, Outlet, Route, RouteProps, Routes, useNavigate } from 'react-router-dom';

import RackPage from 'src/pages/Rack';
import RackElevation from 'src/pages/RackEdit/RackElevation';
import RackSerials from 'src/pages/RackEdit/RackSerials';
import SalesorderList from 'src/pages/Salesorders';
import ScanLooseNodes from 'src/pages/LooseNodeEdit/ScanLooseNodes';
import DisplaySalesorder from 'src/pages/Salesorder/DisplaySalesorder';
import WarrantiesList from 'src/pages/Warranties';
import Index from 'src/pages/Index';
import PageHeader from 'src/widgets/PageHeader';
import PrimaryNav from 'src/widgets/PrimaryNav';
import { ValidateEmail } from './pages/ValidateEmail';
import { Spinner } from 'src/components/Spinner';

import Hedgehog from './assets/images/errorhedgehog.png';


import { useAuth0 } from '@auth0/auth0-react'
import { config } from './config'
import { LoginPage } from './pages/Login';

export default function App() {
  const { isLoading, isAuthenticated, user } = useAuth0();
  const navigate = useNavigate();

  if (isLoading) {
    return <div className="uk-align-center">
      <Spinner />
    </div>
  }


  const params = new URLSearchParams(window.location.search)
  const validateError = params.get('error')
  /*error = access_denied & error_description=Please verify your email before continuing.& state=c05Wdi1*/
  console.log("CHecking param error")
  if (validateError == 'access_denied' && params.get('error_description')?.match(/Email sent to/)) {
    console.log("navigate to validate email")
    navigate('/validateemail')
  }

  if (isAuthenticated && !user) {
    return <div>User error: Authenticated without user data</div>
  }

  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route path="/" element={<Index />} />
        <Route path="/validateemail" element={<ValidateEmail />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/salesorders" element={
          <RequireAuth>
            <SalesorderList />
          </RequireAuth>
        } />
        <Route path="/editsalesorder" element={
          <RequireAuth>
            <DisplaySalesorder />
          </RequireAuth>
        } />
        <Route path="/rack" element={
          <RequireAuth>
            <RackPage />
          </RequireAuth>
        } />
        <Route path="/rackElevation" element={
          <RequireAuth>
            <RackElevation />
          </RequireAuth>
        } />
        <Route path="/rackSerials" element={
          <RequireAuth>
            <RackSerials />
          </RequireAuth>
        } />
        <Route path="/scanNodes" element={
          <RequireAuth>
            {ScanLooseNodes}
          </RequireAuth>
        } />
        <Route path="/warranties" element={
          <RequireAuth>
            <WarrantiesList />
          </RequireAuth>
        } />
        <Route path="/Admin_LoginHistory" element={
          <RequireAuth>
            <Index /> </RequireAuth>
        } />
        <Route path="/*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
function PageLayout() {
  const { isAuthenticated, user } = useAuth0();

  const showNav = isAuthenticated && user;//&& user[`${config.AUTH0_CLAIM_NAMESPACE}/organization_id`];
  const suppressLoginButtons = document.location.pathname == '/validateemail'

  return <div className="App">
    <section className="uk-section uk-padding-remove-top uk-padding-remove-bottom">
      <PageHeader  suppressLoginButtons={suppressLoginButtons} />
      {showNav && <PrimaryNav />}
    </section>
    <section className="uk-section uk-padding-remove-top uk-padding-remove-bottom">
      <div className="uk-conatiner uk-padding" >
        <Outlet />
      </div>
    </section>
  </div >
}

function RequireAuth(props: RouteProps) {
  const { isLoading, isAuthenticated, user } = useAuth0();

  if (isLoading) {
    return <Spinner />
  }
  if (user && !user.email_verified) {
    return <Navigate to="/validateemail" replace />
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }
  return <div className="uk-container uk-container-expand">{props.children}</div>;
}
 
const NotFoundPage = () => {
  return <div className="uk-container">
    <h2>Hmm.... </h2>
    <p>
      We know where a lot of things are, but not whatever you just tried to find.  Try the <Link to="/">Dashboard</Link>.
      <img src={Hedgehog} />
    </p>

  </div>
}